module.exports = fox._r("images/layer.png", __webpack_public_path__ + "_/_/_/affiliate/images/layer.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/affiliate/images/layer.png
// module id = 168
// module chunks = 4